import { useState } from "react";
import { IconEdit } from "@arco-design/web-react/icon";
import { SOAPI } from "@/apis/sales";
import { Button, Input, Modal } from "@arco-design/web-react";

export const EditableNote = (props) => {
    const { onChange, value, soId } = props;
    const [note, setNote] = useState(value);
    const [newNote, setNewNote] = useState(value);
    const [editing, setEditing] = useState(false);

    const save = async () => {
        await SOAPI.updateNote(soId, newNote);
        onChange && onChange(newNote);
        setNote(newNote);
    }

    return (
        <div>
            <span>{note}</span>
            <Button
                type="text"
                size="mini"
                icon={<IconEdit />}
                onClick={() => setEditing(true)} />
            <Modal
                title="Note"
                visible={editing}
                onOk={async () => {
                    await save();
                    setEditing(false);
                }}
                onCancel={() => {
                    setEditing(false);
                    setNewNote(note);
                }}
            >
                <Input.TextArea
                    value={newNote}
                    onChange={(value) => {
                        setNewNote(value);
                    }} />
            </Modal>
        </div>
    );
}
